import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore
import { render } from 'lib';
import App from './App';
var div = document.createElement('div');
document.body.appendChild(div);
render(_jsx(App, {}), div);
